import { Clickable } from 'src/components/clickable';
import { layout } from 'src/components/base';
import styled from 'styled-components';

export const DropdownItem = styled(Clickable)`
  display: block;
  padding: ${layout.measurements.spacing050};
  cursor: pointer;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;
